import { render, staticRenderFns } from "./PrintInvoicesExports.vue?vue&type=template&id=70eb3dcb&"
import script from "./PrintInvoicesExports.vue?vue&type=script&lang=js&"
export * from "./PrintInvoicesExports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports